import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import MenuForm from '../Form';
import { updateOrganization } from '@common/resources/Organization/actions';
import { useIntl } from 'react-intl';

const Menu = (props) => {
	const { updateOrganization, visible, onCancel, organization } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return updateOrganization(organization._id, data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.member.create',
						defaultMessage:
							'A new Menu has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.member',
					defaultMessage: 'Menu Menu',
				})}
			</Title>
			<Section className="mb-5">
				<MenuForm onSubmit={handleSubmit} type={visible} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	users,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		users,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	updateOrganization,
})(Menu);
